(ns lemonpi.specs.interface.adset
  (:require [clojure.spec.alpha :as s]))

;; Copied from lemonpi.geo-location-v2-rest-api.core
(def country-code-to-country-name
  {"af" "afghanistan"
   "ax" "aland islands"
   "al" "albania"
   "dz" "algeria"
   "as" "american samoa"
   "ad" "andorra"
   "ao" "angola"
   "ai" "anguilla"
   "aq" "antarctica"
   "ag" "antigua and barbuda"
   "ar" "argentina"
   "am" "armenia"
   "aw" "aruba"
   "au" "australia"
   "at" "austria"
   "az" "azerbaijan"
   "bs" "bahamas"
   "bh" "bahrain"
   "bd" "bangladesh"
   "bb" "barbados"
   "by" "belarus"
   "be" "belgium"
   "bz" "belize"
   "bj" "benin"
   "bm" "bermuda"
   "bt" "bhutan"
   "bo" "bolivia"
   "ba" "bosnia and herzegovina"
   "bw" "botswana"
   "bv" "bouvet island"
   "br" "brazil"
   "io" "british indian ocean territory"
   "bn" "brunei darussalam"
   "bg" "bulgaria"
   "bf" "burkina faso"
   "bi" "burundi"
   "kh" "cambodia"
   "cm" "cameroon"
   "ca" "canada"
   "cv" "cape verde"
   "bq" "caribbean netherlands"
   "ky" "cayman islands"
   "cf" "central african republic"
   "td" "chad"
   "cl" "chile"
   "cn" "china"
   "cx" "christmas island"
   "cc" "cocos (keeling) islands"
   "co" "colombia"
   "km" "comoros"
   "cg" "congo"
   "ck" "cook islands"
   "cr" "costa rica"
   "ci" "cote d'ivoire"
   "hr" "croatia"
   "cu" "cuba"
   "cw" "curacao"
   "cy" "cyprus"
   "cz" "czech republic"
   "cd" "democratic republic of the congo"
   "dk" "denmark"
   "dj" "djibouti"
   "dm" "dominica"
   "do" "dominican republic"
   "ec" "ecuador"
   "eg" "egypt"
   "sv" "el salvador"
   "gq" "equatorial guinea"
   "er" "eritrea"
   "ee" "estonia"
   "et" "ethiopia"
   "fk" "falkland islands (malvinas)"
   "fo" "faroe islands"
   "fj" "fiji"
   "fi" "finland"
   "fr" "france"
   "gf" "french guiana"
   "pf" "french polynesia"
   "tf" "french southern territories"
   "ga" "gabon"
   "gm" "gambia"
   "ge" "georgia"
   "de" "germany"
   "gh" "ghana"
   "gi" "gibraltar"
   "gr" "greece"
   "gl" "greenland"
   "gd" "grenada"
   "gp" "guadeloupe"
   "gu" "guam"
   "gt" "guatemala"
   "gg" "guernsey"
   "gn" "guinea"
   "gw" "guinea-bissau"
   "gy" "guyana"
   "ht" "haiti"
   "va" "holy see (vatican city state)"
   "hn" "honduras"
   "hk" "hong kong"
   "hu" "hungary"
   "is" "iceland"
   "in" "india"
   "id" "indonesia"
   "ir" "iran"
   "iq" "iraq"
   "ie" "ireland"
   "im" "isle of man"
   "il" "israel"
   "it" "italy"
   "jm" "jamaica"
   "jp" "japan"
   "je" "jersey"
   "jo" "jordan"
   "kz" "kazakhstan"
   "ke" "kenya"
   "ki" "kiribati"
   "kp" "korea (north)"
   "kr" "korea (south)"
   "kw" "kuwait"
   "kg" "kyrgyzstan"
   "la" "laos"
   "lv" "latvia"
   "lb" "lebanon"
   "ls" "lesotho"
   "lr" "liberia"
   "ly" "libya"
   "li" "liechtenstein"
   "lt" "lithuania"
   "lu" "luxembourg"
   "mo" "macau"
   "mk" "macedonia"
   "mg" "madagascar"
   "mw" "malawi"
   "my" "malaysia"
   "mv" "maldives"
   "ml" "mali"
   "mt" "malta"
   "mh" "marshall islands"
   "mq" "martinique"
   "mr" "mauritania"
   "mu" "mauritius"
   "yt" "mayotte"
   "mx" "mexico"
   "fm" "micronesia"
   "md" "moldova"
   "mc" "monaco"
   "mn" "mongolia"
   "me" "montenegro"
   "ms" "montserrat"
   "ma" "morocco"
   "mz" "mozambique"
   "mm" "myanmar"
   "na" "namibia"
   "nr" "nauru"
   "np" "nepal"
   "nl" "the netherlands"
   "nc" "new caledonia"
   "nz" "new zealand"
   "ni" "nicaragua"
   "ne" "niger"
   "ng" "nigeria"
   "nu" "niue"
   "nf" "norfolk island"
   "mp" "northern mariana islands"
   "no" "norway"
   "ps" "occupied palestinian territory"
   "om" "oman"
   "pk" "pakistan"
   "pw" "palau"
   "pa" "panama"
   "pg" "papua new guinea"
   "py" "paraguay"
   "pe" "peru"
   "ph" "philippines"
   "pn" "pitcairn"
   "pl" "poland"
   "pt" "portugal"
   "pr" "puerto rico"
   "qa" "qatar"
   "re" "reunion"
   "ro" "romania"
   "ru" "russian federation"
   "rw" "rwanda"
   "bl" "saint barthelemy"
   "sh" "saint helena"
   "kn" "saint kitts and nevis"
   "lc" "saint lucia"
   "mf" "saint martin"
   "pm" "saint pierre and miquelon"
   "vc" "saint vincent and the grenadines"
   "ws" "samoa"
   "sm" "san marino"
   "st" "sao tome and principe"
   "sa" "saudi arabia"
   "sn" "senegal"
   "rs" "serbia"
   "sc" "seychelles"
   "sl" "sierra leone"
   "sg" "singapore"
   "sx" "sint maarten"
   "sk" "slovak republic"
   "si" "slovenia"
   "sb" "solomon islands"
   "so" "somalia"
   "za" "south africa"
   "gs" "south georgia and the south sandwich islands"
   "ss" "south sudan"
   "es" "spain"
   "lk" "sri lanka"
   "sd" "sudan"
   "sr" "suriname"
   "sj" "svalbard and jan mayen"
   "sz" "swaziland"
   "se" "sweden"
   "ch" "switzerland"
   "sy" "syria"
   "tw" "taiwan"
   "tj" "tajikistan"
   "tz" "tanzania"
   "th" "thailand"
   "tl" "timor-leste"
   "tg" "togo"
   "tk" "tokelau"
   "to" "tonga"
   "tt" "trinidad and tobago"
   "tn" "tunisia"
   "tr" "turkey"
   "tm" "turkmenistan"
   "tc" "turks and caicos islands"
   "tv" "tuvalu"
   "ug" "uganda"
   "ua" "ukraine"
   "ae" "united arab emirates"
   "gb" "united kingdom"
   "um" "united states minor outlying islands"
   "us" "united states"
   "uy" "uruguay"
   "uz" "uzbekistan"
   "vu" "vanuatu"
   "ve" "venezuela"
   "vn" "viet nam"
   "vg" "virgin islands (british)"
   "vi" "virgin islands (u.s.)"
   "wf" "wallis and futuna islands"
   "eh" "western sahara"
   "ye" "yemen"
   "zm" "zambia"
   "zw" "zimbabwe"})

(def date-regex
  #"^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$")

(s/def ::country (into #{} (keys country-code-to-country-name)))
(s/def ::countries (s/coll-of ::country :distinct true :into []))
(s/def ::date (s/and string? #(re-matches date-regex %)))
(s/def ::plannedStart (s/nilable ::date))
(s/def ::plannedEnd (s/nilable ::date))
(s/def ::targetImpressions (s/nilable number?))
